import React, { memo } from 'react';
import styled from 'styled-components';
import { formatProgressRate, formatProgressCount } from '../utils/utils';
import ProgressBar from './ProgressBar';
import type { ReceptionSummary as ReceptionSummaryType } from '../types/types';

type ReceptionSummaryProps = {
	summary: ReceptionSummaryType;
};

// 리셉션 상세 - 집계 정보
const ReceptionSummary = memo<ReceptionSummaryProps>(({ summary }) => {
	return (
		<Wrapper>
			<Row>
				<Label>전체 참가자</Label>
				<Value>{summary.totalParticipants.toLocaleString()} 명</Value>
			</Row>
			<Row>
				<Label>체크인 완료</Label>
				<Value>{summary.checkedInCount.toLocaleString()} 명</Value>
			</Row>
			<Row>
				<Label>미수령</Label>
				<Value>{summary.notReceivedCount.toLocaleString()} 명</Value>
			</Row>
			<Row>
				<Label>진행률</Label>
				<ProgressValue>
					<RateText>{formatProgressRate(summary.progressRate)}</RateText>
					<ProgressBar rate={summary.progressRate} />
					<CountText>{formatProgressCount(summary.checkedInCount, summary.totalParticipants)}</CountText>
				</ProgressValue>
			</Row>
			<Row>
				<Label>처리 방식</Label>
				<Value>
					QR 스캔 {summary.qrCount.toLocaleString()}건 · 수동 체크인{' '}
					<Highlight>
						{summary.manualCount.toLocaleString()}건 ({formatProgressRate(summary.manualRate)})
					</Highlight>
				</Value>
			</Row>
			<Row>
				<Label>체크인 취소</Label>
				<Value>{summary.canceledCount.toLocaleString()}건</Value>
			</Row>
		</Wrapper>
	);
});

ReceptionSummary.displayName = 'ReceptionSummary';

export default ReceptionSummary;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
`;
const Row = styled.div`
	display: flex;
	align-items: center;
`;
const Label = styled.div`
	width: 140px;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
`;
const Value = styled.div`
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.blackColor};
	flex: 1;
`;
const ProgressValue = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	flex: 1;
`;
const RateText = styled.div`
	min-width: 56px;
	${({ theme }) => theme.typography.body2};
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
`;
const CountText = styled.div`
	width: 140px;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
`;
const Highlight = styled.span`
	color: ${({ theme }) => theme.colors.activeRedOrange};
`;
